import {i18n} from '../../../../translate/i18n'

export function typeUser(typePluginspace: string): {select: string; value: string}[] {
  let specificUsers: {select: string; value: string}[] = []

  switch (typePluginspace) {
    case 'hospitality': // Adicionar novos tipos de usuários aqui
      specificUsers = [
        {select: i18n.t(`users.houserkeeping`), value: 'housekeeper'},
        {select: i18n.t(`users.floormanager`), value: 'floormanager'},
        {select: i18n.t(`users.governancesupervisor`), value: 'governancesupervisor'},
        {select: i18n.t(`users.generalservicesassistant`), value: 'generalservicesassistant'},
        {select: i18n.t(`users.laundryattendant`), value: 'laundryattendant'},
        {select: i18n.t(`users.laundrymanager`), value: 'laundrymanager'},
        {select: i18n.t(`users.machinist`), value: 'machinist'},
        {select: i18n.t(`users.ironer`), value: 'ironer'},
        {select: i18n.t(`users.maintenancetechnician`), value: 'maintenancetechnician'},
        {select: i18n.t(`users.electrician`), value: 'electrician'},
        {select: i18n.t(`users.plumber`), value: 'plumber'},
        {select: i18n.t(`users.airconditiontechnician`), value: 'airconditiontechnician'},
        {select: i18n.t(`users.carpenter`), value: 'carpenter'},
        {select: i18n.t(`users.maintenancesupervisor`), value: 'maintenancesupervisor'},
        {select: i18n.t(`users.receptionist`), value: 'receptionist'},
        {select: i18n.t(`users.receptionsupervisor`), value: 'receptionsupervisor'},
        {select: i18n.t(`users.messenger`), value: 'messenger'},
        {select: i18n.t(`users.telephonist`), value: 'telephonist'},
        {select: i18n.t(`users.concierge`), value: 'concierge'},
        {select: i18n.t(`users.waiter`), value: 'waiter'},
        {select: i18n.t(`users.cook`), value: 'cook'},
        {select: i18n.t(`users.kitchenchief`), value: 'kitchenchief'},
        {select: i18n.t(`users.barman`), value: 'barman'},
        {select: i18n.t(`users.roomserviceattendant`), value: 'roomserviceattendant'},
        {select: i18n.t(`users.steward`), value: 'steward'},
        {select: i18n.t(`users.sommelier`), value: 'sommelier'},
        {select: i18n.t(`users.warehouse`), value: 'warehouse'},
        {select: i18n.t(`users.reservationagent`), value: 'reservationagent'},
        {select: i18n.t(`users.reservationcoordinator`), value: 'reservationcoordinator'},
        {select: i18n.t(`users.salesexecutive`), value: 'salesexecutive'},
        {select: i18n.t(`users.revenuemanager`), value: 'revenuemanager'},
        {select: i18n.t(`users.commercialmanager`), value: 'commercialmanager'},
        {select: i18n.t(`users.administrativeassistant`), value: 'administrativeassistant'},
        {select: i18n.t(`users.financeaccountspayable`), value: 'financeaccountspayable'},
        {select: i18n.t(`users.accountant`), value: 'accountant'},
        {select: i18n.t(`users.humanresources`), value: 'humanresources'},
        {select: i18n.t(`users.purchasingwarehouse`), value: 'purchasingwarehouse'},
        {select: i18n.t(`users.recreator`), value: 'recreator'},
        {select: i18n.t(`users.activityinstructor`), value: 'activityinstructor'},
        {select: i18n.t(`users.experiencecoordinator`), value: 'experiencecoordinator'},
        {select: i18n.t(`users.tourguide`), value: 'tourguide'},
        {select: i18n.t(`users.childmonitor`), value: 'childmonitor'},
        {select: i18n.t(`users.securityguard`), value: 'securityguard'},
        {select: i18n.t(`users.doorman`), value: 'doorman'},
        {select: i18n.t(`users.accesscontroller`), value: 'accesscontroller'},
        {select: i18n.t(`users.securitysupervisor`), value: 'securitysupervisor'},
        {select: i18n.t(`users.generalmanager`), value: 'generalmanager'},
        {select: i18n.t(`users.assistantmanager`), value: 'assistantmanager'},
        {select: i18n.t(`users.operationalmanager`), value: 'operationalmanager'},
        {
          select: i18n.t(`users.departmentsupervisorscoordinators`),
          value: 'departmentsupervisorscoordinators',
        },
      ]
      break

    case 'aggregator':
      specificUsers = []
      break

    case 'food':
      specificUsers = []
      break

    default:
      specificUsers = [{select: 'Vendedor', value: 'seller'}]
      break
  }

  return specificUsers
}
